import React from 'react';

const Avatar = ({ 
    size = "lg", 
    color = "#0000ff33", 
    type = "square", 
    children, 
    style = {} 
}) => {

    let _size = "4rem"
    switch (size) {

        case "sm":
            _size = "3rem"
            break;

        case "md":
            _size = "4rem"
            break;

        case "lg":
            _size = "8rem"
            break;

        case "xl":
            _size = "10rem"
            break;

        default:
            break;

    }

    const _style = {
        width: _size,
        margin: "auto",
        height: _size,
        borderRadius: type === "circle" ? "50%" : "9px",
        background: color,
        display: 'flex',
        justifyContent: "center",
        alignItems: "center",
        ...style
    }

    return (
        <div style={_style}>
            {children}
        </div>
    );
};

export default Avatar;